const defaultState = {
   doctors: [],
   count: 0,
   agentId: null,
  };
  
  export default (state = defaultState, action) => {
    switch (action.type) {
  
      case 'DOCTORS':
        const doctors = action.payload.users;
        const count = action.payload.count;
        const agentId = null;
        
        return {
          ...state,
         doctors,
         count,
         agentId,
        };
  
      default:
        return state;
    }
  };
  